import { useState } from "react";

import styled from "styled-components";

import { Controls } from "./Controls";
import { useInterval } from "./hooks/useInterval";

import { Images } from "./Images";

type Props = {
  imageUrls: string[];
  showArrows?: boolean;
  showChickenNuggets?: boolean;
  autoplay?: boolean;
  autoplayInterval?: number;
  onPrevImage?: (...args: unknown[]) => unknown;
  onNextImage?: (...args: unknown[]) => unknown;
  className?: string;
  id?: string;
  testId?: string;
};

export enum ImageCarouselTestIds {
  Container = "ImageCarousel",
}

export const ImageCarousel = ({
  imageUrls,
  showArrows = true,
  showChickenNuggets = true,
  autoplay = false,
  autoplayInterval = 5000,
  onPrevImage = () => {},
  onNextImage = () => {},
  className,
  id,
  testId,
}: Props) => {
  const [index, setIndex] = useState(0);

  const resetAutoplay = useInterval(
    () => setIndex((index) => (index + 1) % imageUrls.length),
    autoplay ? autoplayInterval : null
  );

  const prevImage = () => {
    onPrevImage();
    setIndex((index) => (index === 0 ? imageUrls.length - 1 : index - 1));
    resetAutoplay();
  };

  const nextImage = () => {
    onNextImage();
    setIndex((index) => (index + 1) % imageUrls.length);
    resetAutoplay();
  };

  return (
    <Container
      className={className}
      id={id}
      data-testid={testId ?? ImageCarouselTestIds.Container}
    >
      <Images {...{ imageUrls, index }} />
      <Controls
        {...{
          imageUrls,
          showArrows,
          showChickenNuggets,
          index,
          setIndex,
          prevImage,
          nextImage,
        }}
      />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;
